const prefix = '@qubic-pass';

export const STORAGE_KEYS = {
  QUBIC_PASS_AUTH: `${prefix}/auth`,
  SETTINGS_LOCALE: `${prefix}/settingsLocale`,
};
